var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 4V5.5H19L16 10L19 14.5H8V20H6V4H8Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }